import { render, staticRenderFns } from "./GraphqlCodeDisplay.vue?vue&type=template&id=097f2700&"
import script from "./GraphqlCodeDisplay.vue?vue&type=script&lang=js&"
export * from "./GraphqlCodeDisplay.vue?vue&type=script&lang=js&"
import style0 from "./GraphqlCodeDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports